import { getInstance } from "../auth/authWrapper";

export const errorHandler = async (request) => {
  const authService = getInstance();
  let response;

  try {
    response = await request
  } catch(err) {
    console.log('Error retrieving data', err);

    
    if(err.status == 401) {
      console.log('Logout:', err);
      
      document.cookie = "auth0.is.authenticated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
      document.cookie = "savedUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
      authService.logout({ returnTo: `${window.location.origin}` });
    }
  }

  return response
}